import { useEffect } from 'react'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { isUnderAge, validateAgeByDocumentType } from './functionsValidation'

import { DatePickerControl } from '@/components/form-controls'
import { DateParser } from '@/utils/dateParser'

interface BirthDateControlProps {
    control: Control<any>
    text: string
    setIsMinor: (isMinor: boolean) => void
    watchDocumentType: string
    watchBirthDate: string
    trigger?: (name: any) => Promise<boolean>
}

export const BirthDateControl = ({
    control,
    text,
    setIsMinor,
    watchDocumentType,
    watchBirthDate,
    trigger
}: BirthDateControlProps): JSX.Element => {
    const { t } = useTranslation()

    // Forzar re-validación cuando cambie el tipo de documento
    useEffect(() => {
        // Evita mostrar "requerido" en la primera carga:
        // solo revalida por tipo de documento cuando ya hay fecha seleccionada.
        if (trigger && watchDocumentType && watchBirthDate) {
            void trigger('birthDate')
        }
    }, [watchDocumentType, watchBirthDate, trigger])

    return (
        <DatePickerControl
            name="birthDate"
            control={control}
            label={t(`${text}.birthDate`)}
            maxDate={new Date()}
            onCustomChange={(value) => {
                const parsed = DateParser.parseDate(String(value))

                if (parsed) {
                    setIsMinor(isUnderAge(parsed))
                }

                // Validar inmediatamente al cambiar la fecha
                if (trigger) {
                    void trigger('birthDate')
                }
            }}
            rules={{
                required: t(`${text}.required.birthDate`),
                validate: (value: Date) => {
                    if (!value) {
                        return true
                    }
                    const parsed = DateParser.parseDate(String(value))
                    const birthDate = parsed ?? new Date(String(value))

                    return validateAgeByDocumentType(
                        birthDate,
                        watchDocumentType,
                        t,
                        text
                    )
                }
            }}
        />
    )
}
